import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { AppState } from '../../../../../types/store';
import { showSubmitModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { Props } from './EmptyState';

type StateProps = Pick<Props, 'profileOwnerUser' | 'isOwner'>;
type DispatchProps = Pick<Props, 'showSubmitModal'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => {
    return {
      profileOwnerUser: getProfileOwnerUser(state),
      isOwner: isCurrentUserProfileOwner(state),
    };
  };

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  showSubmitModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
